/* eslint-disable jira/filename-case */

import noop from 'lodash/noop';
import type {
	InitAttrs,
	AnalyticsWebClient,
} from '@jira/platform__observability-product-analytics-web-client-types';

const SSRAnalyticsWebClient: AnalyticsWebClient = {
	initTime: 0,
	eventCount: 0,
	blockingDuration: 0,
	amplitudeSRAttributesInjector: noop,
	updateAmplitudeSRClient: noop,
	resetBlockingDuration: () => undefined,
	init: (attrs: InitAttrs) => !!attrs,
	sendEvent: noop,
	// @ts-expect-error - TS2741 - Property 'prototype' is missing in type '{}' but required in type 'AnalyticsWebClient'.
	// Replace with lodash/noop
	// oxlint-disable-next-line no-empty-function
	getInstance: () => new Proxy({}, { get: () => () => {} }),
	setSubProduct: noop,
	setUIViewedAttributes: noop,
	removeUIViewedAttribute: noop,
	setEmbeddedProduct: noop,
	clearUIViewedAttributes: noop,
	clearEmbeddedProduct: noop,
	stopApdexEvent: noop,
	setOriginTracingHandlers: noop,
	onNewSessionStarted: noop,
	setUpdateAmplitudeSRClient: noop,
	setAmplitudeSRAttributesInjector: noop,
	isInitialized: () => false,
};

export default SSRAnalyticsWebClient;
